import { render, staticRenderFns } from "./Delivery-barcode.vue?vue&type=template&id=2a409c0e"
import script from "./Delivery-barcode.vue?vue&type=script&lang=js"
export * from "./Delivery-barcode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports